module.exports = __webpack_public_path__ + "c9fa60bc70621399894e939d4f5e9b82.ttf";